import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SideNavAccordionList, SideNavAccordionItem } from 'teacher-ui-client/components/side-nav/accordion'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import mortarboardUnfilled from '@images/icons/mortarboard-unfilled.svg'
import { hash } from '@ember/helper'

export class ReadingTeacherToolkitAccordion extends Component {
  @service sideNav!: SideNavService

  get isVisible() {
    return this.sideNav.showTeacherToolkit
  }

  get showNaplanLink() {
    return this.sideNav.countryCode === 'AU'
  }
  <template>
    {{#if this.isVisible}}
      <SideNavAccordionList
        @iconUrl={{mortarboardUnfilled}}
        @iconAlt="Sidenav cap"
        @label={{t "sideNav.reading.teacherToolkit"}}
      >
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/reading/lower"}}>
          {{t "sideNav.reading.k2TeacherResources"}}
        </SideNavAccordionItem>
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/reading/middle"}}>
          {{t "sideNav.reading.34TeachingResources"}}
        </SideNavAccordionItem>
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/reading/upper"}}>
          {{t "sideNav.reading.56TeachingResources"}}
        </SideNavAccordionItem>

        {{#if this.showNaplanLink}}
          <SideNavAccordionItem
            data-test-teacher-toolkit="naplan"
            @route="subscription-type.teacher-toolkit"
            @query={{hash category="/reading/naplan"}}
          >
            {{t "sideNav.reading.naplan"}}
          </SideNavAccordionItem>
        {{/if}}
        <SideNavAccordionItem @route="subscription-type.big-books">
          {{t "sideNav.reading.bigBooks"}}
        </SideNavAccordionItem>
        <SideNavAccordionItem @route="teacher-resources.curriculum-maps">
          {{t "sideNav.reading.curriculumMap"}}
        </SideNavAccordionItem>
      </SideNavAccordionList>
    {{/if}}
  </template>
}
